import { lazy, Suspense } from "react";

const MyScheduleComponent = lazy(() => import("../../screens/my-schedule"));
const MySchedule = (props) => (
  <Suspense fallback={null}>
    <MyScheduleComponent />
  </Suspense>
);

const MyProfileComponent = lazy(() => import("../../screens/my-profile"));
const MyProfile = (props) => (
  <Suspense fallback={null}>
    <MyProfileComponent />
  </Suspense>
);

const MyProjectsComponent = lazy(() => import("../../screens/my-projects"));
const MyProjects = (props) => (
  <Suspense fallback={null}>
    <MyProjectsComponent />
  </Suspense>
);

const NewInvitationReviewComponent = lazy(
  () =>
    import(
      "../../screens/my-projects/vendor/review-ambassadors/new-invitation-review"
    )
);
const NewInvitationReview = (props) => (
  <Suspense fallback={null}>
    <NewInvitationReviewComponent />
  </Suspense>
);

const ProjectDetailsComponent = lazy(
  () => import("../../screens/project-details")
);
const ProjectDetails = (props) => (
  <Suspense fallback={null}>
    <ProjectDetailsComponent />
  </Suspense>
);

const SettingsComponent = lazy(() => import("../../screens/settings"));
const Settings = (props) => (
  <Suspense fallback={null}>
    <SettingsComponent />
  </Suspense>
);

const InitiativesComponent = lazy(() => import("../../screens/initiatives"));
const Initiatives = (props) => (
  <Suspense fallback={null}>
    <InitiativesComponent />
  </Suspense>
);

const MarketplaceProfileViewComponent = lazy(
  () => import("../../screens/my-profile/marketplace-profile-view")
);
const MarketplaceProfileView = (props) => (
  <Suspense fallback={null}>
    <MarketplaceProfileViewComponent />
  </Suspense>
);

export {
  MyProfile,
  Settings,
  MyProjects,
  NewInvitationReview,
  ProjectDetails,
  MySchedule,
  Initiatives,
  MarketplaceProfileView,
};
